import { useCallback, useEffect, useRef, useState } from 'react';

import { SORT } from '@/components/list-bar/ListBarProfile';
import { getListBookMarkMe } from '@/services/usecase';
import type { IOffer } from '@/types/asset';
import type { IUsecaseItem } from '@/types/usecase';

const PAGE_SIZE = 20;

export interface AssetData {
  id: number;
  picture: string;
  name: string;
  collection: {
    id: number;
    name: string;
  } | null;
  mimeType: string;
  model: {
    id: number;
    name: string;
  };
  description: string;
  offer: IOffer | null;
  prompt: number | null;
  accountAddress: string | null;
  url: string;
  collectionId: number | null;
  isNsfw?: boolean;
}

const useBookMarkProfile = () => {
  const assetDataRef = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [assetData, setAssetData] = useState<IUsecaseItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState(SORT.desc);
  const [search, setSearch] = useState('');

  const getInputParams = useCallback(
    (page: number) => ({
      offset: PAGE_SIZE * (page - 1),
      size: PAGE_SIZE,
      sort: `{"createdAt": "DESC"}`,
    }),
    [],
  );

  const handleGetUseCase = async (page: number) => {
    setLoading(true);

    const res = await getListBookMarkMe(getInputParams(page));
    if (page === 1) {
      assetDataRef.current = [];
      setAssetData([]);
    }
    assetDataRef.current = assetDataRef.current.concat(
      res.data.items?.map((item: any) => item.template),
    );
    setAssetData(assetDataRef.current);
    setLoading(false);
  };

  const loadMore = (page: number) => {
    setCurrentPage(page);
    handleGetUseCase(page);
  };

  useEffect(() => {
    handleGetUseCase(1);
  }, [search, sort]);

  return {
    currentPage,
    setCurrentPage,
    artworks: assetData,
    loading,
    search,
    sort,
    setSearch,
    setSort,
    loadMore,
  };
};

export default useBookMarkProfile;
